import { useState } from "react";
import { careersData } from "@/mocks/homeData";

export default function CareersSection() {
  const [filter, setFilter] = useState("All");
  const categories = ["All", ...new Set(careersData.jobs.map((j) => j.category))];
  const filtered =
    filter === "All"
      ? careersData.jobs
      : careersData.jobs.filter((j) => j.category === filter);

  const handleNavClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="careers" className="w-full py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-10 md:mb-14">
          <div className="max-w-xl">
            <span className="text-sm font-semibold text-primary-500 uppercase tracking-wider">
              Join Our Network
            </span>
            <h2 className="font-heading font-bold text-2xl md:text-3xl lg:text-4xl text-foreground-950 mt-2 mb-4">
              {careersData.headline}
            </h2>
            <p className="text-foreground-700 leading-relaxed">
              {careersData.subheadline}
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-3">
            <button
              onClick={() => handleNavClick("#contact")}
              className="px-5 py-2.5 text-sm font-semibold rounded-md bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              {careersData.ctaSecondary}
            </button>
          </div>
        </div>

        <div className="flex flex-wrap gap-2 mb-6 md:mb-8">
          {categories.map((cat) => (
            <button
              key={cat}
              onClick={() => setFilter(cat)}
              className={`px-4 py-2 text-sm font-medium rounded-full transition-all whitespace-nowrap cursor-pointer ${
                filter === cat
                  ? "bg-primary-500 text-background-50"
                  : "bg-background-200/70 text-foreground-600 hover:text-foreground-950 border border-background-300/60"
              }`}
            >
              {cat}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {filtered.map((job) => (
            <div
              key={job.title}
              className="group bg-background-50 rounded-xl p-5 border border-background-200/70 hover:border-primary-300 transition-all hover:-translate-y-1"
            >
              <div className="flex items-start justify-between mb-3">
                <span
                  className={`inline-block px-2.5 py-1 rounded-full text-xs font-semibold ${
                    job.type === "Full-Time"
                      ? "bg-primary-100 text-primary-700"
                      : "bg-accent-100 text-accent-700"
                  }`}
                >
                  {job.type}
                </span>
                <span className="text-xs text-foreground-500">{job.posted}</span>
              </div>
              <h3 className="font-heading font-semibold text-base md:text-lg text-foreground-950 mb-2">
                {job.title}
              </h3>
              <div className="flex items-center gap-1.5 text-sm text-foreground-600 mb-1">
                <i className="ri-map-pin-line text-foreground-400" />
                {job.location}
              </div>
              <div className="flex items-center gap-1.5 text-sm text-foreground-600">
                <i className="ri-briefcase-line text-foreground-400" />
                {job.category}
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-8 md:mt-10">
          <button
            onClick={() => handleNavClick("#contact")}
            className="inline-flex items-center gap-2 text-sm font-semibold text-primary-500 hover:text-primary-600 transition-colors cursor-pointer"
          >
            {careersData.cta}
            <i className="ri-arrow-right-line" />
          </button>
        </div>
      </div>
    </section>
  );
}